module.exports = __webpack_public_path__ + "static/interact-illustration-9f59613f1525ab202c04e347711fcd29.webp";